import React, { useEffect } from "react";
import styles from "./Succes.module.css";
import { useNavigate } from "react-router-dom";
import { useNavigation } from "../../components/NavigationContext/NavigationContext";
import LanguageSwitcher from "../../components/LanguageSwitcher/LanguageSwitcher";
import { useTranslation } from "../../I18n/Languages/LanguageContext";
import checkmarkIcon from "../../assets/success.svg";

export default function SuccesPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

    const { canAccessSuccess } = useNavigation();

    useEffect(() => {
        const storageAccess = sessionStorage.getItem("successPageAccess") === "true";
      
        if (!canAccessSuccess && !storageAccess) {
          navigate("/", { replace: true });
          return;
        }
      }, [canAccessSuccess, navigate]);
      

  return (
    <div className={styles.container}>
      <div
        style={{
          position: "absolute",
          top: window.innerWidth <= 768 ? "2px" : "20px",
          right: window.innerWidth <= 768 ? "2px" : "20px",
        }}
      >
        <LanguageSwitcher />
      </div>
      <div className={styles.card}>
        <div className={styles.checkmark}>
            <img src={checkmarkIcon}  alt="check"/>
        </div>
        <h1 className={styles.h1red}>{t("applicationSuccess")}</h1>
        <div className={styles.textList}>
          <p className={styles.text}>{t("reviewPolicy")}</p>
          <p className={styles.text}>{t("onlySelected")}</p>
          <p className={styles.text}>{t("confidentiality")}</p>
        </div>
        <div className={styles.buttonContainer}>
          <button
            className={styles.exploreBtnBottom}
            onClick={() => {
                sessionStorage.removeItem("successPageAccess");
                sessionStorage.setItem("scrollToJobs", "true");
                navigate("/#jobs");
              }}
          >
            {t("explorePositions")}
          </button>
        </div>
      </div>
    </div>
  );
}
